import React from 'react'
import { Route, Switch, Redirect, NavLink } from 'react-router-dom'
import NotFoundRoute from "components/routes/NotFound";

import path from "./path";
// import ConnectGaPage, { gaPath } from './Ga'
import ConnectScriptPage, { scriptPath } from './Script'

import styles from './ConnectLayout.scss'


const ConnectLayout = () => (
  <div className={styles.container}>
    <h1> Analytics Settings </h1>
    {/*<div className={styles.nav}>*/}
    {/*  <NavLink to={gaPath} activeClassName={styles.activeLink} className={styles.link} style={{border: '1px solid black'}}> Google Analytics account </NavLink>*/}
    {/*  /!*<NavLink to={scriptPath} activeClassName={styles.activeLink} className={styles.link}> Website script </NavLink>*!/*/}
    {/*  <span className={`${styles.link} ${styles.disabled}`}> Website script (Coming soon) </span>*/}
    {/*  <div className={styles.remain}/>*/}
    {/*</div>*/}

    <div className={styles.content}>
      <Switch>
        <Route exact path={path} component={() => <Redirect to={scriptPath}/>} />
        {/*<Route exact path={gaPath} component={ConnectGaPage} />*/}
        <Route exact path={scriptPath} component={ConnectScriptPage} />

        <Route component={NotFoundRoute} /> {/* 404 */}
      </Switch>
    </div>
  </div>
)

export default ConnectLayout

export const connectPath = path;

